import React from 'react';
import {Tooltip, Typography, withStyles} from '@material-ui/core';
import type {TooltipProps} from '@material-ui/core/Tooltip';
import {TooltipStyles} from 'assets/tss/layouts/components';

const EfeTooltip = ({children, title, ...other}: TooltipProps) => (
    <Tooltip
        title={
            <Typography component='div' variant='caption'>
                {title}
            </Typography>
        }
        {...other}>
        {children}
    </Tooltip>
);

export default withStyles(TooltipStyles)(EfeTooltip);
